<app-toaster></app-toaster>
<app-header class="app-header"></app-header>
<router-outlet></router-outlet>
<app-footer class="app-footer"></app-footer>
